import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, FormControlLabel, Checkbox } from '@material-ui/core/';
import {
  coreRed,
  coreBlue,
  coreDarkBlue,
} from '../../themeprovider/ccmTheme/colorPalette';

const useStyles = makeStyles({
  hylerLinkPolicy: {
    color: coreRed,
    textDecoration: 'none',
    fontSize: '18px',
  },
  checkbox: {
    width: '10px',
    height: '10px',
    marginRight: '10px',
    marginLeft: '10px',
    background: '#FDF6CF',
    color: coreBlue,
  },
  checkboxContainer: {
    paddingTop: '10px',
  },
  error: {
    paddingTop: '15px',
    fontSize: '14px',
    color: coreRed,
  },
});

const FormPrivacyCheckbox = ({
  handleChange,
  checked,
  error,
  showTerms,
  showPrivacy,
}) => {
  const classes = useStyles();

  return (
    <>
      {error && (
        <div className={classes.error} aria-label="checked-error">
          {error || '\u00A0'}
        </div>
      )}
      <div className={classes.checkboxContainer}>
        <FormControlLabel
          control={
            <Checkbox
              id="checked"
              name="checked"
              checked={checked}
              onChange={handleChange}
              className={classes.checkbox}
              color="primary"
            />
          }
          label={
            <div>
              {'I have read and accept the '}
              {showTerms ? (
                <a
                  href="/terms-and-conditions"
                  target="_blank"
                  rel="noopener"
                  className={classes.hylerLinkPolicy}
                >
                  Terms and Conditions
                  {showTerms && showPrivacy ? (
                    <span style={{ color: coreDarkBlue }}> and </span>
                  ) : null}
                </a>
              ) : null}
              {showPrivacy ? (
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener"
                  className={classes.hylerLinkPolicy}
                >
                  Privacy policy
                </a>
              ) : null}
              &nbsp;*
            </div>
          }
        />
      </div>
    </>
  );
};

export default FormPrivacyCheckbox;

FormPrivacyCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  showTerms: PropTypes.bool,
  showPrivacy: PropTypes.bool,
};

FormPrivacyCheckbox.defaultProps = {
  error: '',
  showTerms: true,
  showPrivacy: true,
};
